import {VerifyAPI} from "../api/VerifyAPI";
import {RsDocumentFrontResult} from "../api/dto/RsDocumentFrontResult";
import {RsImageResult} from "../api/dto/RsImageResult";
import {RsInitiateVerification} from "../api/dto/RsInitiateVerification";
import {RsVerification} from "../api/dto/RsVerification";
import {RqInputInformation} from "../api/dto/RqInputInformation";
import {RsVerificationResult} from "../api/dto/RsVerificationResult";
import {DocumentType} from "../domain/verification/DocumentType";
import {ResultStatusType} from "../domain/verification/ResultStatusType";
import {RsCurrentStep} from "../api/dto/RsCurrentStep";
import {RsDocumentType} from "../api/dto/RsDocumentType";
import {RqManuallySkipStep} from "../api/dto/RqManuallySkipStep";

export class VerifyService {

    private static instance: VerifyService;
    private verifyAPI: VerifyAPI

    private constructor() {
        this.verifyAPI = new VerifyAPI();
    }

    async initiateVerification(): Promise<RsInitiateVerification> {
        return await this.verifyAPI.initiateVerification();
    }

    async selectDocumentTemplate(verificationId: string, chosenDocumentId: string): Promise<void> {
        await this.verifyAPI.selectDocumentTemplate(verificationId, chosenDocumentId)
    }

    async giveConsent(verificationId: string): Promise<void> {
        await this.verifyAPI.giveConsent(verificationId)
    }

    async getDocumentType(verificationId: string): Promise<RsDocumentType> {
        return await this.verifyAPI.getDocumentType(verificationId)
    }

    async sendDocumentFront(document: Blob, verificationId: string, documentType?: DocumentType | undefined): Promise<RsDocumentFrontResult> {
        return await this.verifyAPI.sendDocumentFrontImage(document, verificationId, documentType)
    }

    async sendDocumentBack(document: Blob, verificationId: string): Promise<RsImageResult> {
        return await this.verifyAPI.sendDocumentBackImage(document, verificationId)
    }

    async sendSelfie(selfie: Blob, verificationId: string): Promise<RsImageResult> {
        return await this.verifyAPI.sendSelfieImage(selfie, verificationId)
    }

    async sendInputInformation(inputInformation: RqInputInformation, verificationId: string) {
        await this.verifyAPI.sendInputInformation(inputInformation, verificationId)
    }

    async getResult(verificationId: string): Promise<RsVerificationResult> {
        return await this.verifyAPI.getResult(verificationId)
    }

    async getVerification(verificationId: string): Promise<RsVerification> {
        return await this.verifyAPI.getVerification(verificationId)
    }

    async getCurrentStep(verificationId: string): Promise<RsCurrentStep> {
        return await this.verifyAPI.getCurrentStep(verificationId)
    }

    async getExtractionResult(verificationId: string): Promise<ResultStatusType> {
        return await this.verifyAPI.getExtractionResult(verificationId)
    }

    async timeoutDocumentFrontStep(verificationId: string) {
        await this.verifyAPI.timeoutDocumentFrontStep(verificationId)
    }

    async manuallySkipStep(request: RqManuallySkipStep, verificationId: string) {
        await this.verifyAPI.manuallySkipStep(request, verificationId)
    }

    static getInstance() {
        if (!this.instance) {
            this.instance = new VerifyService();
        }
        return this.instance;
    }

}